import apptimizeMixin from './apptimize';


export default {
  mixins: [apptimizeMixin],
  computed: {
    enableLessons() {
      return this.$apptimize?.root?.getBool('enableLessons', false);
    },
    enableLessonsOverride() {
      return this.$store.getters['user/enableLessonsOverride'];
    },
    effectiveLessonsEnabled() {
      // Use override if set, otherwise use Apptimize value
      return this.enableLessonsOverride || this.enableLessons;
    },
    lastVisitedDashboardId() {
      const lastVisitedId = this.$store.getters['dashboards/lastVisitedId'][this.$store.getters['dashboards/lastVisitedId'].length - 1];
      if (lastVisitedId) {
        return lastVisitedId;
      }

      // Fall back to default dashboard if no last visited dashboard
      const defaultDashboard = this.$store.getters['dashboards/dashboard'];
      return defaultDashboard ? defaultDashboard.id : null;
    },
    lastVisitedDashboard() {
      return this.$store.getters['dashboards/get'][this.lastVisitedDashboardId];
    },
    dashboardWidgetsTypes() {
      return this.lastVisitedDashboard?.appDashboardsDashboardWidgets
        .map(w => w.dashboardWidgetId)
        .filter(id => id !== null)
        .map(id => this.$store.getters['dashboardWidgets/widgets'][id])
        .filter(w => w !== null)
        .map(w => w.widgetType) || [];
    },
    hasLessonsWidget() {
      return this.dashboardWidgetsTypes.includes('lesson');
    },
    hasStartWidget() {
      return this.dashboardWidgetsTypes.includes('start');
    },
    showLessonsWidget() {
      if (!this.hasStartWidget) {
        return true;
      }
      if (this.effectiveLessonsEnabled) {
        return true;
      }
      return false;
    },
  },
};
